import "./sprinkles.css.ts.vanilla.css-mistica.js";
import "./select.css.ts.vanilla.css-mistica.js";
var n = "_1sqpivvo _1y2v1nfb0 _1y2v1nffa", f = "_1sqpivvq _1y2v1nf8w _1y2v1nfa5 _1y2v1nf68 _1y2v1nf7h _1y2v1nf1w _1y2v1nfb5 _1y2v1nfbk _1y2v1nfe4 _1y2v1nfck", y = "_1y2v1nf3e", i = {
    show: "_1sqpivv7",
    hide: "_1sqpivv8"
}, s = "_1sqpivv6 _1y2v1nf5z _1y2v1nf78 _1y2v1nf8h _1y2v1nf9q _1y2v1nfb1 _1y2v1nfdv _1y2v1nf31", a = {
    default: "_1sqpivvd _1sqpivvc _1y2v1nfaz _1y2v1nfe4",
    fullWidth: "_1sqpivve _1sqpivvc _1y2v1nfaz _1y2v1nfe4"
}, e = {
    default: "_1sqpivvl _1sqpivvk _1y2v1nfb0 _1y2v1nfe5 _1y2v1nfdk _1y2v1nf1w",
    disabled: "_1sqpivvm _1sqpivvk _1y2v1nfb0 _1y2v1nfe5 _1y2v1nfdk _1y2v1nf1w"
}, r = {
    default: "_1sqpivvh _1sqpivvg _1y2v1nfdn _1y2v1nfe5 _1y2v1nf1w _1y2v1nf5y _1y2v1nfbs _1y2v1nfc9",
    disabled: "_1sqpivvi _1sqpivvg _1y2v1nfdn _1y2v1nfe5 _1y2v1nf1w _1y2v1nf5y _1y2v1nfbs _1y2v1nfc9"
}, p = {
    top: "var(--_1sqpivv0)",
    left: "var(--_1sqpivv1)",
    transformOrigin: "var(--_1sqpivv2)",
    minWidth: "var(--_1sqpivv3)",
    maxHeight: "var(--_1sqpivv4)"
};
export { n as arrowDown, f as menuItem, y as menuItemSelected, i as optionsAnimationsVariants, s as optionsContainer, a as selectContainerVariants, e as selectTextVariants, r as selectVariants, p as vars };
